import React, { useState, useEffect, memo } from 'react';
import Lozenge from '@atlaskit/lozenge';
import { getFlags } from '@atlassian/jira-common-have-i-seen-it';
import log from '@atlassian/jira-common-util-logging/src/log';
import { useIntl } from '@atlassian/jira-intl';
import { PACKAGE_LOCATION } from './constants';
import { messages } from './messages';

export const NewLozenge = memo(({ flag, testId }: { flag: string; testId?: string }) => {
	const [isLozengeVisible, setIsLozengeVisible] = useState(false);
	const { formatMessage } = useIntl();

	useEffect(() => {
		if (__SERVER__) {
			return;
		}

		getFlags({ [flag]: {} })
			.then((response) => {
				if (!response[flag]?.status) {
					setIsLozengeVisible(true);
				}
			})
			.catch(() => {
				log.safeErrorWithoutCustomerData(PACKAGE_LOCATION, 'Failed to fetch have-i-seen-it flags.');
			});
	}, [flag]);

	return isLozengeVisible ? (
		<>
			<Lozenge appearance="new" testId={testId}>
				{formatMessage(messages.new)}
			</Lozenge>
		</>
	) : null;
});
